import { useEffect, useRef } from 'react';
import { isTypingTarget } from './preTimingShortcuts';

export const useInlineAddShortcut = (
  group: string,
  matches: (event: KeyboardEvent) => boolean,
  onTrigger: () => void,
  enabled: boolean,
) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!enabled) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (!matches(event) || isTypingTarget(event.target)) return;
      const root = ref.current;
      if (!root) return;

      const owners = Array.from(
        document.querySelectorAll<HTMLElement>(`[data-inline-add="${group}"]`),
      );
      if (!owners.includes(root)) return;

      const active = document.activeElement;
      const focused = owners.find((node) => node.contains(active));
      if ((focused ?? owners[owners.length - 1]) !== root) return;

      event.preventDefault();
      onTrigger();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [enabled, group, matches, onTrigger]);

  return ref;
};
